import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ReportService } from '../report.service';
import { UtilService } from '../../../service/util.service';
import { IonicSelectableComponent } from 'ionic-selectable';
import { Storage } from '@ionic/storage';
import { UserProfile } from '../../../models/user-profile.model';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
import * as XLSX from 'xlsx';
import { ReportStockPointComponent } from '../../../component/report-stock-point/report-stock-point.component';
import { ReportCashierCounterListComponent } from '../../../component/report-cashier-counter-list/report-cashier-counter-list.component';

@Component({
  selector: 'app-report-point-redeem',
  templateUrl: './report-point-redeem.page.html',
  styleUrls: ['./report-point-redeem.page.scss'],
})
export class ReportPointRedeemPage implements OnInit {

  @Input() counterList: any[];

  @ViewChild('counterComponent', { static: false }) counterComponent: IonicSelectableComponent


  dataReport = [];
  counters:any[]=[];
  counterId:any ='';
  counterData:any=[];
  counterByLogin : any;
  token: any;
  userProfile: UserProfile = new UserProfile();
  selectedCounters: any[]=[];
  selectedRange = 'today';
  startDate: string;
  endDate: string;
  formattedRange = '';
  data: any[] = [];
  showBtnCounterList:boolean=false;
  constructor(
    private storage: Storage,
    private reportService: ReportService,
    private utilService:UtilService,
    private alertController:AlertController,
    private toastCtrl:ToastController,
    private modalController:ModalController
  ) {}

  ngOnInit() {  
    Promise.all([
        this.storage.get('user_token'),
        this.storage.get('user_profile')
    ])
    .then(([token, profile]) => {
      if(token) {
        this.setDefaultToday();
        this.token = token;
        this.utilService.loadingPresent('Harap tunggu...')
        .then(() => {
          this.userProfile = new UserProfile(profile);
          this.counterByLogin = this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list;
          this.utilService.loadingDismiss();
          let options = { 
            "token": this.token,
            "branch_id": '',
            "counter_id": this.counterByLogin 
          };
          this.reportService.getCounterByBranchId(options).subscribe((response) => {
            this.utilService.loadingDismiss();
            this.counterData = [];
            this.counterData = response.results;
            let checkedCounter =this.counterId !=='' ? this.counterId :this.counterByLogin ;
            let counterIdSplit = checkedCounter !== '' ? String(checkedCounter).split(',') : [];
            let idCounter='';
            for(let i= 0; i < checkedCounter.length; i++) {
              let selectedCounter: any = this.counterData.find(x => x.id ==  counterIdSplit[i]);
              if(selectedCounter){
                let idx =this.counterData.indexOf(selectedCounter);
                this.selectedCounters.push(this.counterData[idx]);          
                idCounter += this.counterData[idx]['id']+',';
              }
            }
            idCounter = idCounter.replace(/(^,)|(,$)/g, "");
            this.counterId = idCounter;
            let loopCounter = 0;
            if(this.selectedCounters.length >5) {
              loopCounter = 5;
              this.showBtnCounterList = true;
            } else {
              loopCounter = this.selectedCounters.length;
              this.showBtnCounterList = false;
            }
            this.getData();
          }, () => {});
        })
      }    
    })
  }
  ionViewDidEnter(){}
  setDefaultToday() {
    const today = new Date();
    const dateStr = today.toISOString().split('T')[0];
    this.startDate = dateStr;
    this.endDate = dateStr;
    this.formattedRange = this.formatDateRange(today, today);
  }

  async getData(){
    if (!this.startDate || !this.endDate) {
      const alert = await this.alertController.create({
        header: 'Peringatan',
        message: 'Periode tanggal belum lengkap.',
        buttons: ['OK'],
      });
      await alert.present();
      return;
    }
    if ( !this.counterId) {
      this.presentAlert('Mohon Pilih Counter  terlebih dahulu!');
      return;
    }
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      this.dataReport = [];
      let options={
        "counter_id":this.counterId,
        "start_date":this.startDate,
        "end_date":this.endDate
      }
    this.reportService.reportPointRedeem(options).subscribe((response) => {
      this.utilService.loadingDismiss();
      console.log(response)
      if (response.status.code == 200) {
        this.dataReport = response.results;
      }
    }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal mendapatkan data Report!' }).then(t => t.present());
      });
    });
  }
  async presentAlert(message: string) {
    const alert = await this.alertController.create({
      message: message,
      buttons: ['OK'],
    });
    await alert.present();
  }

  applyFilter() {
    this.getData();
  }

  toggleCounterItems() {
    this.counterComponent.toggleItems(
      this.counterComponent.itemsToConfirm.length ? false : true
    );
  }

  confirmCounter() {
    this.counterComponent.confirm();
    this.counterComponent.close();  
    this.counterList = [];
    this.counterList = this.counterComponent.value;
    let idCounter ='';
    for(let i=0;i<this.counterList.length;i++){
      idCounter += this.counterList[i].id+',';
    }
    idCounter = idCounter.replace(/(^,)|(,$)/g, "");
    this.counterId = idCounter;
  }

  cleanValue(val: any): number | string {
    const num = Number(val);
    if (isNaN(num)) return val;
    return num === 0 ? 0 : num;
  }

  exportToExcel() {
    let dataForExport = [];
    if(this.dataReport.length>0){
      for (let i = 0; i < this.dataReport.length; i++) {
        const item = this.dataReport[i];
        dataForExport.push({
          No: i + 1,
          "Counter ID": item.counter_id,
          "Counter Name": item.counter_name,
          "Customer ID": item.customer_id,
          "Customer Name": item.customer_name,
          "No HP": item.phone,
          "Gender": item.gender,
          "Tanggal Lahir": item.birth_date,
          "Tier": item.tier_name,
          "Provinsi": item.province_name,
          "Poin Redeem": item.point,
          "Value Poin Redeem":item.point_value,
          "Redeem Date": item.trans_date
        });
      }
    }
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataForExport);
    
    const objectMaxLength: number[] = [];
    dataForExport.forEach(row => {
      Object.values(row).forEach((value, colIndex) => {
        const length = String(value).length;
        objectMaxLength[colIndex] = Math.max(objectMaxLength[colIndex] || 0, length);
      });
    });
    Object.keys(dataForExport[0]).forEach((header, colIndex) => {
      objectMaxLength[colIndex] = Math.max(objectMaxLength[colIndex] || 0, header.length);
    });
    ws['!cols'] = objectMaxLength.map(width => ({ wch: width + 2 }));
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'Laporan Redeem Point.xlsx');
  }

  applyPreset() {
    const today = new Date();
    let start: Date, end: Date;

    switch (this.selectedRange) {
      case 'today':
        start = end = today;
        break;
      case '7days':
        start = new Date(today);
        start.setDate(today.getDate() - 6);
        end = today;
        break;
      case '30days':
        start = new Date(today);
        start.setDate(today.getDate() - 29);
        end = today;
        break;
      case 'month':
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case 'custom':
        // tunggu user pilih manual
        return;
    }

    this.startDate = start.toISOString().split('T')[0];
    this.endDate = end.toISOString().split('T')[0];
    this.formattedRange = this.formatDateRange(start, end);
  }

  async applyCustom() {
    const start = new Date(this.startDate);
    const end = new Date(this.endDate);
    this.formattedRange = this.formatDateRange(start, end);
    // 🧩 VALIDASI: pastikan tanggal akhir tidak kurang dari tanggal awal
    if (end < start) {
      const toast = await this.toastCtrl.create({
        message: 'Tanggal "Sampai" tidak boleh lebih awal dari "Dari".',
        duration: 2500,
        color: 'danger',
        position: 'top'
      });
      toast.present();
      return;
    }
    this.getData();
  }

  formatDateRange(start: Date, end: Date) {
    const opt: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' };
    return `${start.toLocaleDateString('id-ID', opt)} - ${end.toLocaleDateString('id-ID', opt)}`;
  }
  
  async showCounterList() {
    const modal = await this.modalController.create({
      component: ReportCashierCounterListComponent,
      componentProps: {
        counterList: this.selectedCounters
      },
      backdropDismiss: false
    });
    return await modal.present();
  }
}
